import { Tooltip } from 'flowbite-react';
import React from 'react';

import type { CompanyDataResponse } from '../../../../@types/Company';
import type { Federation } from '../../../../utils/companyListFilters';

const fnaimLogo = require('../../../../../img/FNAIM.png');
const unisLogo = require('../../../../../img/UNIS.webp');
const snpiLogo = require('../../../../../img/SNPI.png');

const FEDERATION_LOGOS = [
  { key: 'fnaim', label: 'FNAIM', src: fnaimLogo, rowClass: 'h-6 w-7' },
  { key: 'unis', label: 'UNIS', src: unisLogo, rowClass: 'h-5 w-10' },
  { key: 'snpi', label: 'SNPI', src: snpiLogo, rowClass: 'h-5 w-6' },
] as const;

const MUTED = 'opacity-30 grayscale';

interface FederationLogosProps {
  details: Partial<Pick<CompanyDataResponse, Federation>> | null | undefined;
  /** row: small logos of a table cell; header: large logos with a tooltip, as on the company page. */
  variant?: 'row' | 'header';
}

/** FNAIM / UNIS / SNPI logos, greyed out when the company is not a member. */
export function FederationLogos({ details, variant = 'row' }: FederationLogosProps) {
  if (variant === 'header') {
    return (
      <>
        {FEDERATION_LOGOS.map(({ key, label, src }) => (
          <div key={key} className="shrink-0">
            <Tooltip
              content={details?.[key] ? `Est adhérent ${label}` : `N'est pas adhérent ${label}`}
              placement="bottom"
            >
              <img
                src={src}
                alt={details?.[key] ? `Adhérent ${label}` : `Non adhérent ${label}`}
                className={`h-8 w-10 object-contain xl:h-12 xl:w-16 ${details?.[key] ? '' : MUTED}`}
              />
            </Tooltip>
          </div>
        ))}
      </>
    );
  }

  return (
    <div className="flex justify-center space-x-2">
      {FEDERATION_LOGOS.map(({ key, label, src, rowClass }) => (
        <img
          key={key}
          src={src}
          alt={details?.[key] ? `Adhérent ${label}` : `Non adhérent ${label}`}
          className={`${rowClass} ${details?.[key] ? '' : MUTED}`}
        />
      ))}
    </div>
  );
}

/** Legend of the logos shown in the rows. */
export function FederationLegend() {
  return (
    <div className="mb-4 text-sm">
      <h3 className="mb-2 font-semibold">Légende des fédérations :</h3>
      <div className="items-center gap-8 md:flex">
        {FEDERATION_LOGOS.map(({ key, label, src, rowClass }) => (
          <React.Fragment key={key}>
            <div className="mb-2 flex items-center md:mb-0">
              <img src={src} alt="" className={`mr-2 ${rowClass}`} />
              <span>Membre {label}</span>
            </div>
            <div className="mb-2 flex items-center md:mb-0">
              <img src={src} alt="" className={`mr-2 ${rowClass} ${MUTED}`} />
              <span>Non-membre {label}</span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
